
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/address",
      function () {
        return require("private-next-pages/my-account/address.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/address"])
      });
    }
  